module.exports = __webpack_public_path__ + "static/media/how-to-swab-step-03-2x.850706fe.png";